<template>
  <v-layout column>
    <v-stepper v-model="stepperIndex" vertical>
    <v-container text-xs-center>
      <h2 v-if="!farm.id" class="title">New Farm</h2>
      <h2 v-if="farm.id" class="title">Edit {{farm.name}}</h2>
    </v-container>
      <v-stepper-step editable :complete="stepperIndex > 1" step="1">
        Basic Info
      </v-stepper-step>

      <v-stepper-content step="1">
        <form>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field label="Farm Name" v-model="basicInfoForm.name" @input="$v.basicInfoForm.name.$touch()" @blur="$v.basicInfoForm.name.$touch()" :error-messages="getBasicInfosErrorMessage('name')"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="City" v-model="basicInfoForm.city" @input="$v.basicInfoForm.city.$touch()" @blur="$v.basicInfoForm.city.$touch()" :error-messages="getBasicInfosErrorMessage('city')"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-select :items="countries" item-text="name" item-value="key" v-model="basicInfoForm.country_code" label="Country" @input="$v.basicInfoForm.country_code.$touch()" @blur="$v.basicInfoForm.country_code.$touch()" :error-messages="getBasicInfosErrorMessage('country_code')"></v-select>
              </v-flex>
              <v-flex xs12>
                <v-text-field label="Address" v-model="basicInfoForm.address" @input="$v.basicInfoForm.address.$touch()" @blur="$v.basicInfoForm.address.$touch()" :error-messages="getBasicInfosErrorMessage('address')"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Latitude" v-model="basicInfoForm.lat" @input="$v.basicInfoForm.lat.$touch()" @blur="$v.basicInfoForm.lat.$touch()" :error-messages="getBasicInfosErrorMessage('lat')"></v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field label="Longitude" v-model="basicInfoForm.lng" @input="$v.basicInfoForm.lng.$touch()" @blur="$v.basicInfoForm.lng.$touch()" :error-messages="getBasicInfosErrorMessage('lng')"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-layout align-center justify-end row>
            <v-btn @click="handleClose()" flat color="primary">cancel</v-btn>
            <v-btn @click="validateFarmBasicInfo()" raised color="primary">next</v-btn>
          </v-layout>
        </form>
      </v-stepper-content>

      <v-stepper-step :complete="stepperIndex > 2" step="2">
        Certificates
      </v-stepper-step>

      <v-stepper-content step="2">
        <form>
          <v-container grid-list-md>
            <v-layout v-for="(certificate, index) in certificationForm"  :key="`certificate-${index}`" class="certificate-row" row>
              <div v-if="!certificate.id && index >= 1" class="delete-certificate-row-btn">
                <v-btn @click="handleDeleteCertificate(index)" icon>
                  <v-icon color="red">remove_circle_outline</v-icon>
                </v-btn>
              </div>
              <v-flex shrink class="index font-weight-regular">
                {{index + 1}}
              </v-flex>
              <v-flex grow>
                <v-text-field label="Certificate Name" v-model="certificate.title" @input="$v.certificationForm.$each.$iter[index].title.$touch()" @blur="$v.certificationForm.$each.$iter[index].title.$touch()" :error-messages="getCertificateErrorMessage('title', index)"></v-text-field>
                <v-menu
                  v-model="certificate.issueDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="certificate.issued_at"
                    label="Certification Issue Date"
                    @blur="$v.certificationForm.$each.$iter[index].issued_at.$touch()"
                    :error-messages="getCertificateErrorMessage('issued_at', index)"
                    append-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker no-title v-model="certificate.issued_at" @input="certificate.issueDateMenu = false; $v.certificationForm.$each.$iter[index].issued_at.$touch()"></v-date-picker>
                </v-menu>
                <v-menu
                  v-model="certificate.expiryDateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="certificate.expires_at"
                    label="Certification Expiry Date"
                    append-icon="event"
                    @blur="$v.certificationForm.$each.$iter[index].expires_at.$touch()"
                    :error-messages="getCertificateErrorMessage('expires_at', index)"
                    readonly
                  ></v-text-field>
                  <v-date-picker no-title v-model="certificate.expires_at" @input="certificate.expiryDateMenu = false;$v.certificationForm.$each.$iter[index].expires_at.$touch()" ></v-date-picker>
                </v-menu>
              </v-flex>
              <div class="file-upload-ctn">
                <v-layout  class="upload-btn" align-center justify-center column>
                  <div @click="clickOnFileInput($event, `certificateFile-${index}`)" v-if="typeof certificate.file !== 'string' && !certificate.file.name" class="text-xs-center">
                    <v-icon x-large color="primary">cloud_upload</v-icon>
                    <div class="text-uppercase font-weight-bold">Choose file</div>
                    <div class="format-hint">
                      Supported formats:<br>
                      PDF/JPG/PNG
                    </div>
                    <div class="error--text">
                      <div :key="i" v-for="(message, i) in getCertificateErrorMessage('file', index)">{{message}}</div>
                    </div>
                  </div>

                  <div @click="clickOnFileInput($event, `certificateFile-${index}`)" v-if="certificate.file && certificate.file.name" class="text-xs-center">
                    <v-icon x-large color="primary">cloud_upload</v-icon>
                    <div class="text-uppercase font-weight-bold">Change File</div>
                    <div class="format-hint">
                      {{certificate.file.name}}
                    </div>
                  </div>

                  <div v-if="typeof certificate.file === 'string'">
                    <v-btn color="primary" block raised :href="certificate.file" target="_blank">Preview Certificate</v-btn>
                    <v-btn @click="clickOnFileInput($event, `certificateFile-${index}`)" color="primary" block flat>Change Certificate File</v-btn>
                  </div>

                </v-layout>
                <input v-show="false" accept=".pdf,.png,.jpg,.jpeg" @change="processCertificateFile($event, certificate)" type="file" :ref="`certificateFile-${index}`" />
              </div>
            </v-layout>
          </v-container>
          <v-layout align-center justify-end row>
            <v-flex grow>
              <v-btn flat color="primary" @click="addCertificate()">Add certificate</v-btn>
            </v-flex>
            <v-btn @click="handleClose()" flat color="primary">cancel</v-btn>
            <v-btn @click="validateCertificateInfos()" raised :disabled="submitting" color="primary">submit</v-btn>
          </v-layout>
        </form>
      </v-stepper-content>

    </v-stepper>
  </v-layout>

</template>

<script>

import { required } from 'vuelidate/lib/validators'
import { countriesMap } from '@/utils/countries'

export default {
  name: 'FarmForm',
  props: ['farmId', 'farm', 'certificates'],
  data () {
    return {
      countries: countriesMap(),
      farmValidationErrorMsg: {},
      certificateValidationErrorMsg: [],
      stepperIndex: 1,
      submitting: false,
      basicInfoForm: {
        type: 'farm',
        name: '',
        city: '',
        country_code: '',
        address: '',
        lat: '',
        lng: ''
      },
      certificationForm: [{
        title: '',
        issued_at: '',
        expires_at: '',
        file: {}
      }]
    }
  },
  validations () {
    return {
      basicInfoForm: {
        name: { required },
        city: { required },
        country_code: { required },
        address: { required },
        lat: { required },
        lng: { required }
      },
      certificationForm: {
        $each: {
          title: { required },
          issued_at: { required },
          expires_at: { required },
          file: { required }
        }
      }
    }
  },
  created () {
    if (this.farm.id) {
      this.basicInfoForm = {
        ...this.farm
      }
    }

    if (this.certificates.length) {
      this.certificationForm = this.certificates
    }
  },
  methods: {

    handleDeleteCertificate (index) {
      this.certificationForm.splice(index, 1)
    },

    clickOnFileInput (event, inputName) {
      event.stopImmediatePropagation()
      this.$refs[inputName][0].click()
    },

    processCertificateFile (event, certificate) {
      setTimeout(() => {
        certificate.file = event.target.files[0]
      })
    },

    getCertificateErrorMessage (field, index) {
      let errors = []

      if (!this.$v.certificationForm.$each.$iter[index][field].$dirty) return errors
      for (let key in this.$v.certificationForm.$each.$iter[index][field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.certificationForm.$each.$iter[index][field].required && errors.push('This field is is required.')
      }

      if (this.certificateValidationErrorMsg[index] && this.certificateValidationErrorMsg[index][field]) {
        errors.push(this.certificateValidationErrorMsg[index][field][0])
      }

      return errors
    },

    getBasicInfosErrorMessage (field) {
      let errors = []

      if (!this.$v.basicInfoForm[field].$dirty) return errors
      for (let key in this.$v.basicInfoForm[field].$params) {
        // Add more key here is needed for other type of error messages
        if (key === 'required') !this.$v.basicInfoForm[field].required && errors.push('This field is is required.')
      }

      if (this.farmValidationErrorMsg[field]) {
        errors.push(this.farmValidationErrorMsg[field][0])
      }

      return errors
    },

    addCertificate () {
      let newCertificate = {
        title: '',
        issued_at: '',
        expires_at: '',
        file: {}
      }

      this.certificationForm.push(newCertificate)
    },

    handleClose () {
      this.$emit('on-close-dialog')
    },

    validateCertificateInfos () {
      if (this.$v.certificationForm.$invalid) {
        this.$v.certificationForm.$touch()
      } else {
        if (!this.farm.id) {
          this.createFarm()
        } else {
          this.updateFarm()
        }
      }
    },

    validateFarmBasicInfo () {
      if (this.$v.basicInfoForm.$invalid) {
        this.$v.basicInfoForm.$touch()
      } else {
        this.stepperIndex = 2
      }
    },

    updateFarm () {
      this.$store.dispatch('updateFarm', { farm: this.basicInfoForm }).then((farmId) => {
        let promises = []
        this.certificationForm.forEach((certificate) => {
          certificate.location = farmId
          if (!certificate.id) {
            promises.push(this.$store.dispatch('createCertificate', { certificate: certificate }))
          } else {
            promises.push(this.$store.dispatch('updateCertificate', { certificate: certificate }))
          }
        })

        Promise.all(promises).then(() => {
          this.$emit('on-close-dialog')
          this.$store.dispatch('showSnackBar', { message: 'Farm and certificates updated successfully.' })
        }).catch((err) => {
          this.$store.dispatch('showSnackBar', { message: err })
        })
      })
    },

    createFarm () {
      this.submitting = true
      this.$store.dispatch('createFarm', { farm: this.basicInfoForm }).then((farmId) => {
        let promises = []
        this.certificationForm.forEach((certificate) => {
          certificate.location = farmId
          promises.push(this.$store.dispatch('createCertificate', { certificate: certificate }))
        })

        promises.forEach((promise, index) => {
          promise.catch((error) => {
            this.certificateValidationErrorMsg[index] = {}
            for (let key in error.response.data) {
              this.certificateValidationErrorMsg[index][key] = error.response.data[key]
            }
          })
        })

        Promise.all(promises).then(() => {
          this.$emit('on-close-dialog')
          this.$store.dispatch('showSnackBar', { message: 'Farm and certificates created successfully.' })
          this.submitting = false
        }).catch(() => {
          this.submitting = false
        })
      }).catch((err) => {
        for (let key in err.response.data) {
          this.farmValidationErrorMsg[key] = err.response.data[key]
        }
        this.stepperIndex = 1
        this.submitting = false
      })
    }
  }
}

</script>

<style lang="scss" scoped>
.flex {
  padding: 5px;
}

.index {
  font-size: 24px;
  color: black;
  opacity: 0.3;
  margin-right: 10px;
}

.certificate-row{
  position: relative;
  margin-top: 10px !important;
  background: #fafafa;
  padding: 10px;
}

.delete-certificate-row-btn{
  position: absolute;
  top: 0;
  right: 0;
}

.file-upload-ctn{
  width: 240px;
  margin-left: 20px;
}

.upload-btn{
  width: 100%;
  height: 100%;
  background: #fafafa;
  padding: 15px;
  cursor: pointer;
  .v-icon{
    width: 35px;
  }
  .format-hint{
    word-break: break-all;
    margin-top: 15px;
  }
  .text-uppercase{
    color: #378e07;
    font-size: 14px;
  }
}
</style>
